import React from 'react';
interface MainScreenProps {
  popoverShow: () => void;
  popoverHide: () => void;
  handleOrderPressRef: {current: (orderId: number) => () => void};
  handleShowRecordRef: {current: (recordId: number) => void};
  handleOrderPress: (args: {
    popoverHide: () => void;
    handleOrderPressRef: () => void;
  }) => () => void;
  props: {
    contentComponent: React.ElementType;
    contentProps?: Record<string, any>;
  };
  navigation: any;
  route: any;
}

export const MainScreen: React.FC<MainScreenProps> = ({
  handleOrderPressRef,
  handleShowRecordRef,
  handleOrderPress,
  popoverShow,
  popoverHide,
  props: {contentComponent: ContentComponent, contentProps = {}},
  navigation,
  route,
}) => {
  return (
    <ContentComponent
      {...contentProps}
      navigation={navigation}
      route={route}
      recordsShowPopover={popoverShow}
      recordsShowRecord={handleShowRecordRef?.current}
      onOrderPress={(orderId: any) =>
        handleOrderPress({
          popoverHide,
          handleOrderPressRef: handleOrderPressRef?.current(orderId),
        })()
      }
    />
  );
};
